import { OK } from 'http-status-codes';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { createAction } from 'redux-actions';
import '../../../server/util/AppError';

import callApi from '../../util/apiCaller';

import { setError, setOk } from '../App/AppActions';

export const getCheckoutPageCb = createAction('GET_CHECKOUT_PAGE_CB');
export const addSubscriptionCb = createAction('ADD_SUBSCRIPTION_CB');
export const checkSubscriptionCb = createAction('CHECK_SUBSCRIPTION_CB');

export function getCheckoutPage(_, planId, locale, navigate) {
  return dispatch => {
    return callApi(dispatch, 'users/checkout-pages', null, 'POST', { planId, locale })
      .then(res => {
        if (res.status === OK) {
          const hostedPage = res.hosted_page || res;
          const { id, url } = hostedPage;
          dispatch(
            getCheckoutPageCb({
              id,
              url,
              planId,
            }),
          );
          navigate('/subscriptions/checkout');
        }
      })
      .catch(response => {
        if (
          response.errors &&
          response.errors.user &&
          response.errors.user === 'had_subscription'
        ) {
          dispatch(
            setError(
              <FormattedMessage
                id="Subscription.HadSubscription"
                defaultMessage="You already had an active subscription. Go to {subscriptionSettings}."
                values={{
                  subscriptionSettings: (
                    <Link to="/settings/billing">
                      <FormattedMessage
                        id="Subscription.SubscriptionSettings"
                        defaultMessage="subscription settings"
                      />
                    </Link>
                  ),
                }}
              />,
            ),
          );
        } else {
          dispatch(
            setError(
              <FormattedMessage
                id="Subscription.CreationError"
                defaultMessage="There was an error creating subscription, please try again."
              />,
            ),
          );
        }
      });
  };
}

export function confirmCheckoutSession(sessionId, replace) {
  return dispatch =>
    callApi(dispatch, 'users/subscriptions/confirm-checkout', null, 'POST', { sessionId })
      .then(res => {
        if (res.status === OK || res.subscription) {
          dispatch(addSubscriptionCb(res.subscription));
          replace('/settings/billing');
          setTimeout(
            () =>
              dispatch(
                setOk(
                  <FormattedMessage
                    id="Subscription.Created"
                    defaultMessage="Subscription created successfully."
                  />,
                ),
              ),
            500,
          );
        }
      })
      .catch(() => {
        replace('/pricing');
        setTimeout(
          () =>
            dispatch(
              setError(
                <FormattedMessage
                  id="Subscription.CreationError"
                  defaultMessage="There was an error creating subscription, please try again."
                />,
              ),
            ),
          500,
        );
      });
}

export function addSubscription(_, hostedPageId, replace) {
  return dispatch => {
    return callApi(dispatch, 'users/subscriptions', null, 'POST', { hostedPageId })
      .then(res => {
        if (res.status === OK) {
          replace('/');
          dispatch(addSubscriptionCb(res.subscription));
          setTimeout(
            () =>
              dispatch(
                setOk(
                  <FormattedMessage
                    id="Subscription.Created"
                    defaultMessage="Subscription created successfully."
                  />,
                ),
              ),
            500,
          );
        }
      })
      .catch(() => {
        replace('/pricing');
        setTimeout(
          () =>
            dispatch(
              setError(
                <FormattedMessage
                  id="Subscription.CreationError"
                  defaultMessage="There was an error creating subscription, please try again."
                />,
              ),
            ),
          500,
        );
      });
  };
}

export function checkSubscriptionAction() {
  return dispatch => {
    return callApi(dispatch, 'users/subscriptions/check', null, 'GET').then(res => {
      dispatch(checkSubscriptionCb(res.subscription));
    });
  };
}
